import './ShippingLabelsFilter.scss';

import { FilterFilled, FilterOutlined } from '@ant-design/icons';
import { useForm } from '@refinedev/antd';
import { Button, Form, Popover } from 'antd';
import { useCallback, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import AntdSelect from '@/components/general/AntdSelect/AntdSelect';
import FullscreenDrawer from '@/components/general/Drawers/FullscreenDrawer';
import { useUiContext } from '@/contexts/UiContext';
import { Shipment } from '@/model/Logistic/Shipment/Shipment';

import { useShippingLabelsFilter } from './useShippingLabelsFilter';

interface ShippingLabelsFilterProps {
  filters: any[];
  setFilters: Function;
  setCurrent: Function;
}

const ShippingLabelsFilter = (props: ShippingLabelsFilterProps) => {
  const { t } = useTranslation();
  const { isMobile } = useUiContext();
  const [filterPopoverOpen, setFilterPopoverOpen] = useState(false);
  const { formProps } = useForm<Shipment>({ warnWhenUnsavedChanges: false });
  const { form } = formProps;
  const { filters, setFilters, setCurrent } = props;
  const { companySelectProps } = useShippingLabelsFilter(formProps, filters);
  const handleClearFilters = useCallback(() => {
    form?.resetFields();
    setFilters([], 'replace');
    setCurrent(1);
    setFilterPopoverOpen(false);
  }, [form, setCurrent, setFilters]);
  const applyFilters = useCallback(
    values => {
      const filters: any[] = [];

      // Empresa
      if (values.company) {
        filters.push({
          field: 'empresa',
          operator: 'eq',
          value: values.company,
        });
      }

      setFilters(filters, 'replace');
      setCurrent(1);
      setFilterPopoverOpen(false);
    },
    [setFilters, setFilterPopoverOpen, setCurrent],
  );
  const filterContent = useMemo(
    () => (
      <Form
        labelAlign="left"
        {...formProps}
        style={{ marginBottom: 8 }}
        onFinish={applyFilters}
        className="ShippingLabelsFilterPopover">
        <div className="ShippingLabelsFilterPopoverRows">
          <Form.Item label={t('Empresa')} name={'company'} className="ShippingLabelsFilterRow">
            {/* <CompanySelector showFullName {...companySelectProps} allowClear showSearch /> */}
            <AntdSelect {...companySelectProps} allowClear showSearch />
          </Form.Item>
        </div>

        <div className="ShippingLabelsFilterActions">
          <Button type="default" style={{ marginLeft: 8 }} onClick={() => handleClearFilters()}>
            {t('Limpiar')}
          </Button>
          <Button htmlType="submit" type="primary">
            {t('Buscar')}
          </Button>
        </div>
      </Form>
    ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [companySelectProps],
  );

  return (
    <div className="ShippingLabelsFilter">
      {isMobile ? (
        <>
          <Button
            className={filters.length > 0 ? 'ShippingLabelsFilterApplied' : ''}
            onClick={() => setFilterPopoverOpen(true)}
            icon={<FilterOutlined />}
          />
          <FullscreenDrawer
            disablePush
            title={t('Filtros')}
            open={filterPopoverOpen}
            setOpen={setFilterPopoverOpen}>
            {filterContent}
          </FullscreenDrawer>
        </>
      ) : (
        <Popover
          openClassName="ShippingLabelsFilterPopover"
          content={filterContent}
          title={t('Filtros')}
          trigger="click"
          open={filterPopoverOpen}
          onOpenChange={setFilterPopoverOpen}
          placement="bottomRight">
          <Button
            className={filters.length > 0 ? 'ShippingLabelsFilterApplied' : ''}
            icon={filters.length > 0 ? <FilterFilled /> : <FilterOutlined />}>
            {t('Filtrar')}
          </Button>
        </Popover>
      )}
    </div>
  );
};

export default ShippingLabelsFilter;
